import React from "react";
import WithCss from "./WithCss";
import { useWidgetConfiguration } from "../configuration";
const WithGlobalCss = ({ children }) => {
    const { sharedCssUrls, useGlobalCss } = useWidgetConfiguration();
    const styles = useGlobalCss
        ? sharedCssUrls?.map((url) => `@import url(${url});`).join("\n")
        : undefined;
    return <WithCss styles={styles}>{children}</WithCss>;
};
export default WithGlobalCss;
